import React, { useContext } from 'react';
import ModalContext from '../Modal/ModalContext';
import TicketscanLimitForm from '../TicketscanLimitForm';
import SpinToWinLimitForm from '../SpinToWinLimitForm';

// Use this component as the base for a modal comment
// form so that the modal's buttons have access to submit the form.
function ModalParametersForm({ formType = 'ticketscan', ...props }) {
  const { setSubmitFn, setSubmitDisabled } = useContext(ModalContext);

  const formProps = {
    ...props,
    setOuterSubmitFn: setSubmitFn,
    setOuterSubmitDisabled: setSubmitDisabled,
  };

  if (formType === 'spinToWin') {
    return <SpinToWinLimitForm {...formProps} />;
  }

  return <TicketscanLimitForm {...formProps} />;
}

export default ModalParametersForm;
